import servise from '@/router/axios'

// 应用报表查询
export const fetchApplicationlist = (params) => {
    return servise({
        url: '/webReportKeyword/Application/list',
        method: 'get',
        params
    })
}

// 应用报表二级报表查询
export const fetchApplicationDetailList = (params) => {
    return servise({
        url: '/webReportKeyword/Application/detail',
        method: 'get',
        params
    })
}

// 配置支出低价
export const updateApplicationOut = (data) => {
    return servise({
        url: '/webReportKeyword/Application/out',
        method: 'post',
        data
    })
}

// 配置收入低价
export const updateApplicationIn = (data) => {
    return servise({
        url: '/webReportKeyword/Application/in',
        method: 'post',
        data
    })
}
